import { MouseEventHandler, useState } from "react";
import { EmailFlowLogReport } from "@dashboard-v3/api";
import {
  Link,
  List,
  ListItem,
  Popover,
  PopoverProps,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface FiltersHelperProps {
  filters: EmailFlowLogReport["filters"];
}

export function FiltersHelper({ filters }: FiltersHelperProps) {
  const { t } = useTranslation("emailFlowLogs");
  const [openFilters, setOpenFilters] = useState(false);
  const [filtersAnchor, setFiltersAnchor] = useState(null);
  const popoverProps: Partial<PopoverProps> = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
  };

  const onFilterOpen: MouseEventHandler<HTMLAnchorElement> = e => {
    setFiltersAnchor(e.currentTarget);
    setOpenFilters(prev => !prev);
  };

  return (
    <Link style={{ cursor: "pointer" }} onClick={onFilterOpen}>
      <Popover
        open={openFilters}
        anchorEl={filtersAnchor}
        anchorOrigin={popoverProps.anchorOrigin}
        transformOrigin={popoverProps.transformOrigin}
      >
        <List>
          {Object.entries(filters).map(item => {
            const [filterName, value] = item;
            const filterValue = filterName.includes("date")
              ? new Date(value as number).toLocaleString()
              : value;

            return (
              <ListItem key={`${filterName}-${value}`} style={{ gap: 5 }}>
                <Typography variant="subtitle2">
                  {t(`report.filters.${filterName}`)}
                </Typography>
                {typeof filterValue !== "boolean" && (
                  <Typography variant="body2">
                    {filterName === "status"
                      ? t(`search.status.option.${filterValue}`)
                      : filterValue}
                  </Typography>
                )}
              </ListItem>
            );
          })}
        </List>
      </Popover>
      {t("report.filters.helper", { count: Object.keys(filters).length })}
    </Link>
  );
}
